var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgListIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.619751,
    width: 51.3803,
    height: 48,
    rx: 6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8096 14H29.1906C32.2796 14 33.9996 15.78 33.9996 18.83V29.16C33.9996 32.26 32.2796 34 29.1906 34H20.8096C17.7696 34 15.9996 32.26 15.9996 29.16V18.83C15.9996 15.78 17.7696 14 20.8096 14ZM21.0796 18.66V18.65H24.0686C24.4996 18.65 24.8496 19 24.8496 19.429C24.8496 19.87 24.4996 20.22 24.0686 20.22H21.0796C20.6486 20.22 20.2996 19.87 20.2996 19.44C20.2996 19.01 20.6486 18.66 21.0796 18.66ZM21.0796 24.74H28.9196C29.3496 24.74 29.6996 24.39 29.6996 23.96C29.6996 23.53 29.3496 23.179 28.9196 23.179H21.0796C20.6486 23.179 20.2996 23.53 20.2996 23.96C20.2996 24.39 20.6486 24.74 21.0796 24.74ZM21.0796 29.31H28.9196C29.3186 29.27 29.6196 28.929 29.6196 28.53C29.6196 28.12 29.3186 27.78 28.9196 27.74H21.0796C20.7796 27.71 20.4896 27.85 20.3296 28.11C20.1696 28.36 20.1696 28.69 20.3296 28.95C20.4896 29.2 20.7796 29.35 21.0796 29.31Z",
    fill: "#262626"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/listIcon.d8c43488.svg";
export { ForwardRef as ReactComponent };